import { Brick, registerBrick, Config, Auth, CloudObject, User } from 'olympe';

export default class CreateOwnersAndMembersPayload extends Brick {

    /**
       * @override
       * @protected
       * @param {!BrickContext} $
       * @param {string} userObjectID
       * @param {function()} forwardEvent
       * @param {function(Map)} setUsers
       */
    update($, [userObjectID], [forwardEvent, setUsers]) {
        const techUserObjectUPN = Config.getParameter('techUserObjectUPN') || '';
        const techUserObjectID = Config.getParameter('techUserObjectID') || '';
        const loggedInUserMail = CloudObject.get(Auth.getCurrentUser()).get(User.loginProp);
        const isEqual = techUserObjectUPN.localeCompare(loggedInUserMail, undefined, { sensitivity: 'base' }) === 0;
        const ownerList = isEqual ? [techUserObjectID] : [userObjectID, techUserObjectID];
        const memberList = [userObjectID];
        const users = new Map([
            ["owners@odata.bind", ownerList],
            ["members@odata.bind", memberList]
        ]);
        setUsers(users);
        forwardEvent();
    }
}

registerBrick('018fb60165369a6bc84e', CreateOwnersAndMembersPayload);
